import Dinero from 'dinero.js';
import { CalculateFinancialSummaryRequest } from '../../../../../../clients/quipli-service/financials/financials';
import { Order, OrderProduct } from '../../../../../../clients/quipli-service/order/order';
import { ProductType } from '../../../../../../clients/quipli-service/product/product';
import { EditableField } from '../../../../../../components/field/field';
import Icon from '../../../../../../components/icons/icon';
import { safeRound } from '../../../../../../util/util';

export const OffRentGridProductRow = ({
  orderProduct,
  isSelectedForReturn,
  existingAmount,
  lateChargeAmount,
  waiveLateCharge,
  order,
  currency,
  value,
  setLateChargeSummaryRequest,
}: {
  orderProduct: OrderProduct;
  isSelectedForReturn: boolean | undefined;
  existingAmount?: Dinero.Dinero;
  lateChargeAmount?: Dinero.Dinero;
  waiveLateCharge: boolean;
  order: Order;
  currency: Dinero.Currency | undefined;
  value: Dinero.Dinero | undefined;
  setLateChargeSummaryRequest: React.Dispatch<React.SetStateAction<CalculateFinancialSummaryRequest | undefined>>;
}) => {
  const productName = orderProduct.product.type === ProductType.Custom ? orderProduct.name : orderProduct.product.name;

  return (
    <>
      {/* col 1-2*/}
      <div className={`col-span-2`}>{productName}</div>

      <>
        {/* col 3 */}
        {isSelectedForReturn ? (
          <Icon icon="Check" data-cy="off-rent-grid-product-row-selected" className="text-[var(--grey-200)]" />
        ) : (
          <div data-cy="off-rent-grid-product-row-not-selected"></div>
        )}

        {/* col 4 */}
        <div key={`${orderProduct.id}-original`} className=" items-center gap-2">
          {!order?.isCycleBilled && existingAmount?.toFormat()}
        </div>

        {/* col 5 */}
        <div key={`${orderProduct.id}-late`} className="items-center gap-2">
          {waiveLateCharge ? (
            <span className="text-[var(--grey-200)]" data-cy="off-rent-grid-product-row-waived">
              {value?.toFormat()}
            </span>
          ) : !order.isCycleBilled ? (
            <EditableField
              type="number"
              value={value?.toUnit()}
              formattedValue={value?.toFormat()}
              resetPosition="right"
              onChange={(value) => {
                setLateChargeSummaryRequest((prev) => {
                  if (prev && typeof value === 'number') {
                    const idx = prev.items.findIndex((i) => i.id === orderProduct.id.toString());
                    return {
                      ...prev,
                      items: [
                        ...prev.items.filter((item, i) => i !== idx),
                        {
                          ...prev.items[idx],
                          customPrice:
                            existingAmount!
                              .add(
                                Dinero({
                                  amount: safeRound((value || 0) * 100),
                                  currency,
                                }),
                              )
                              .toUnit() * 100,
                        },
                      ],
                    };
                  }
                  return prev;
                });
              }}
            />
          ) : (
            <div />
          )}
        </div>

        {/* col 6 */}
        {!order.isCycleBilled ? (
          <div
            key={`${orderProduct.id}-total`}
            data-cy="off-rent-grid-product-row-total"
            className="items-center gap-2"
          >
            {waiveLateCharge ? existingAmount?.toFormat() : lateChargeAmount?.toFormat()}
          </div>
        ) : (
          <div></div>
        )}
      </>
    </>
  );
};
